query GetAudienceMembershipDeltas($audienceId: ID!) {
    audience(id: $audienceId) {
        id
        membershipStats {
            totalCountDelta {
                direction
                percentChange
                timespanSuffix
            }
        }
    }
}
